/* globals define */

define(['immutable'], (Immutable) => { // eslint-disable-line import/no-amd
  const APP_ID = '156085c5-0017-4150-b225-a731ad248f38';

  // The default popup and animation template database id
  const DEFAULT_TEMPLATE_ID = 'd1b28f5d-d834-4eab-bed8-505338512f5d';

  const SHAKE_ANIMATION = Immutable.Map({ slug: 'shake', duration: 1000 });

  const SLUG_TO_FEATURE = {
    feature: {
      title: 'Feature',
      feature: 'features',
    },
    template: {
      title: 'Template',
      feature: 'templates',
    },
    json: {
      title: 'Popup',
      feature: 'features',
    },
    animation: {
      title: 'Animation',
      feature: 'animations',
    },
    size: {
      title: 'Size',
      feature: 'sizes',
    },
    service: {
      title: 'Service',
      feature: 'services',
    },
  };

  const FormTypes = {
    POPUP: 'popup',
    SCROLL_BOX: 'scroll-box',
    WELCOME_MAT: 'welcome-mat',
    SMART_BAR: 'smart-bar',
    INLINE_POPUP: 'inline-popup',
    CLICK_TRIGGER_POPUP: 'click-trigger-popup',
    GAME: 'game',
  };

  const FormGoals = {
    EMAILS: 'emails',
    PUSH: 'push',
    CTA: 'cta',
    SOCIAL: 'social',
    CUSTOM: 'custom',
    SOCIAL_PROOF: 'social-proof',
  };

  const TESTABLE_FORM_TYPES = [
    FormTypes.POPUP,
    FormTypes.SCROLL_BOX,
    FormTypes.WELCOME_MAT,
    FormTypes.SMART_BAR,
  ];

  const DISCOUNT_PRO_TIERS = [
    'Big',
    'Sumo',
    4,
    5,
  ];

  // Constants for embedded popup Inline Focus blackout functionality
  const InlineClassnames = {
    LIGHT: 'embed-light',
    DARK: 'embed-blackout',
  };

  const TAB_FORM_TYPES = [
    FormTypes.POPUP,
    FormTypes.GAME,
    FormTypes.SCROLL_BOX,
    FormTypes.CLICK_TRIGGER_POPUP,
  ];

  const ResponsiveFormats = ['small', 'medium'];

  // Sumo badge bottom/top placement css px absolute value, used in PopupScale and SumoBadge
  const SUMO_BADGE_PLACEMENT_VAL = 38;

  // Sumo badge css height from listbuilder-popup.scss
  const SUMO_BADGE_HEIGHT_VAL = 28;

  const GOALS = [
    {
      type: FormGoals.EMAILS,
      title: 'Collect Emails',
      description: 'I want to collect my visitor\'s email addresses and/or other information.',
    }, {
      type: FormGoals.PUSH,
      title: 'Collect Push Notification Subscribers',
      description: 'I want visitors to allow me to send them push notifications. (Chrome & Firefox only)',
    }, {
      type: FormGoals.CTA,
      title: 'Add a Call to Action',
      description: 'I want to point users to a specific URL with a button.',
    }, {
      type: FormGoals.SOCIAL,
      title: 'Get Social Shares',
      description: 'I want to get my site more social traffic through X, Facebook, or Pinterest.',
      variants: [
        {
          type: 'twitter',
          title: 'X',
        }, {
          type: 'facebook',
          title: 'Facebook',
        }, {
          type: 'pinterest',
          title: 'Pinterest',
        },
      ],
    }, {
      type: FormGoals.CUSTOM,
      title: 'Collect Info With Custom Code',
      description: 'I want to collect my visitor\'s email addresses and/or other information with custom HTML I coded.',
    }, {
      type: FormGoals.SOCIAL_PROOF,
      title: 'Display Social Proof',
      description: 'I want to incentivize visitors to take action based on other visitor\'s action.',
      locked: true,
    }
  ];

  const FORM_TYPES = [
    {
      type: FormTypes.GAME,
      title: 'Cart Casino',
      iconClassName: 'game',
      description: 'Show a fun high-converting popup game.',
    },
    {
      type: FormTypes.POPUP,
      title: 'Popup',
      iconClassName: 'popup',
      description: 'Show a popup box in the middle of your page.',
    },
    {
      type: FormTypes.SCROLL_BOX,
      title: 'Scroll Box',
      iconClassName: 'scroll-box',
      description: 'Show a popup box that sticks to the bottom of your page.',
    },
    {
      type: FormTypes.INLINE_POPUP,
      title: 'Inline Form',
      iconClassName: 'inline-popup',
      description: 'Show a form box that is inline with the content of your page.',
    },
    {
      type: FormTypes.CLICK_TRIGGER_POPUP,
      title: 'Click Trigger Popup',
      iconClassName: 'click-trigger-popup',
      description: 'Show a popup in the middle of your page that is activated by a link click.',
    },
    {
      type: FormTypes.WELCOME_MAT,
      title: 'Welcome Mat',
      iconClassName: 'welcome-mat',
      description: 'Show a form that covers your entire page.',
    },
    {
      type: FormTypes.SMART_BAR,
      title: 'Smart Bar',
      iconClassName: 'smart-bar',
      description: 'Show a bar that sticks to the top of your page.',
    },
  ];

  const ECOMMERCE_TEMPLATE_IDS = [
    '045a15c6-591b-4656-a3d1-c327fd22c2c8',
    '05bdf74c-f4ed-489f-af16-6031d2aee515',
    '0a338eca-bdb9-47a5-9c4d-92cb87802e38',
    '0b74103d-57e9-48af-a58d-8461ff42529e',
    '0c300870-a0bc-41ae-b476-7e670a22edd4',
    '0ebade9c-4e44-4fc0-b055-daa1631d94b4',
    '125adcb4-5282-42cf-98c7-8266a4f48591',
    '1e5a6100-fe5b-4a69-8321-de1f8196c1c5',
    '20191276-86ae-4909-b5c0-85184449300a',
    '236258a3-2e3c-4b4e-be94-1b8f24e9fa41',
    '26f42f31-67e9-4e2c-8ae5-45557da47096',
    '2b121961-2a86-4ddf-9fe9-bbc965c5d805',
    '2de7f060-5174-4767-bc52-720ca9bea4c3',
    '31728d29-b5ec-471a-bf9f-171092a1c55f',
    '3231804a-dfde-4931-ac98-afd4f7a432ba',
    '3449ed74-8be1-43a2-9c73-078ea20ae1f8',
    '360f3360-1bf8-4676-8f6c-d1a38f395e21',
    '36b2134c-c8cc-41c8-ba3f-06cab3069263',
    '371737cb-cbcd-410b-9853-a04f6115cae3',
    '38c8266e-1f60-475d-a2ae-c9d2449a30e2',
    '3d291569-df30-4ce5-8b15-0f04ac09f589',
    '4024fae7-8b5b-452a-b1e9-8205cd0a0f82',
    '42b1bf99-7338-4f61-865d-47b25854b757',
    '448a4f83-8aa3-46ed-ab1b-b4fc01e26dbe',
    '4562cd84-72f8-4a08-8786-a642195f7398',
    '45e70f43-7096-4875-b887-db88bbb1ac8b',
    '480c6888-04a6-4515-9ab1-3323c5f9c39d',
    '48d4317e-7960-4a99-99c1-837d9abde82d',
    '4ab81347-f385-41f5-a784-9341876ba982',
    '4bf608f4-6837-4559-bb5e-bce454c5355d',
    '4c68d26d-646d-4a78-90a2-f70196802137',
    '51328bcd-421a-4347-8e4e-1535bbd16b51',
    '535bf38d-e8f0-4c85-8683-94a8777fb8d3',
    '547fb1f2-8077-4958-9a4c-ba2ac5bb4933',
    '5a73007e-a107-4b9d-8d86-48ce9b9e3205',
    '5c6c9b98-cafa-401b-853b-3680849a33a9',
    '603ab669-e014-4339-b005-1555dcf57edd',
    '63ecf099-8a14-4df6-bf3c-6e626309241d',
    '642babc6-7821-4b73-8214-7df6993ddb5b',
    '6b8e9f93-ad8f-4a90-9046-ea60c57fdc7a',
    '6e7ef0fd-51cc-4b57-8f96-fc489c98f7ef',
    '7076008b-5928-49fc-aabf-1c508ff2d3f8',
    '70ba7052-f531-4dd7-9fc1-9af8780fe4b9',
    '724bc528-3577-4c8e-b1cd-494a727b4e06',
    '79de1548-a6b6-449d-a09f-50331da61f5e',
    '7c8ded36-187d-4687-b7ab-1bb596bfd317',
    '812f7e6f-1a1c-4f3a-b5b9-2b8f7c9a9ecf',
    '821153eb-a62c-474e-99b2-645917155fca',
    '834ed518-3863-4ce1-8da4-3202a79b667a',
    '85a2a744-1a22-4bd7-b931-4e67bf71444f',
    '86ffa847-2c40-4847-8a5b-21100080cc06',
    '86ffa847-2c40-4847-8a5b-60cc08000112',
    '88debfb2-3473-4cda-b782-a98354509cc4',
    '895de682-98fd-4e9e-b73f-94e714b63bed',
    '89992dbf-0b67-49eb-ac05-369e5ed74621',
    '8b4f8253-ca74-4b00-a869-9e9a2829ed2d',
    '8deaf20d-3f51-4a31-b105-4dddb7c407fc',
    '9047a78a-1cd3-4641-a581-59977d895783',
    '92124840-23a6-4d47-a21f-ac398e319756',
    '96ac0d39-c8c0-4a7f-b936-bcead6fda32c',
    '9fd36707-f8b6-4fee-8532-c5cdd5f76a8c',
    'a47a53ba-c6a4-40d9-b019-62210854ce26',
    'a893cc4b-8de2-4d0f-ad29-4d1a22861121',
    'b5f710b4-fea8-458d-b0d8-ddbd3c9965a6',
    'b6d82379-4d94-4955-8d75-dc7cf4a0c832',
    'b7c47ce3-d10e-4437-9a2b-57b884e180b5',
    'ba30f4c1-338c-4486-81e1-028ef760241d',
    'bbec646c-014a-431b-84a9-c0e038a6abe2',
    'bc4197f0-b458-406a-81cb-e127c1c0e6df',
    'bcc50351-fe30-4fb6-9bb9-8c4178b79e37',
    'be99c014-c391-489d-b377-46c537835912',
    'beeb835c-8c46-4e77-8720-d9f560ddeb1b',
    'bf0659f6-2502-405c-b313-b532cc624c4b',
    'c507615f-e986-42ca-b98c-27ccf27d29a5',
    'c7ff542e-5eec-44b2-b630-e7f37aed3758',
    'c9c04076-ec1e-4f62-b83d-9c8c739af607',
    'cd2c2c36-8dd9-4285-a5e2-eb0208501629',
    'cf3cd46b-ff26-4e72-b815-eec093a560a7',
    'd34e128c-6e6a-44af-adfb-bd127d0273b5',
    'd5d7bd79-27d6-4f43-943b-7ba35696f625',
    'db86069d-b98a-44f7-939f-8e097b1fdd16',
    'dccd5b6e-9bc6-47f3-b12b-0aed840f3f90',
    'e0676eb2-c8f4-407c-ac47-c385157b828d',
    'e0ed465f-1cae-4dc0-ad51-17c36b94350f',
    'e61149fc-1084-4858-8774-490aed2626c3',
    'e6a2f0f6-2c49-43b7-95ad-9c8a055ef4b2',
    'e71fe595-19f3-4b75-8c40-98c9a0c6bfaa',
    'e74a032d-2348-4c5d-9bb6-249a80774f0e',
    'ec2bc3d3-bf29-4c6c-a1b6-4ef385610729',
    'ecd73d82-b401-4c4c-bfad-b56f237c52ce',
    'ed76a995-be72-4fb2-915f-e2187b003853',
    'ed867a12-95f3-463c-8695-b71d94e5e4eb',
    'eebce741-4d8c-414d-97b8-36e2231bf0d6',
    'f09799ee-56fa-441e-8cfb-4fb1d0c16244',
    'f0ffce9d-f73f-4878-b432-cb04f3fe3bf8',
    'f1787577-e779-4d48-91c6-7527bd83a566',
    'f27cd247-9263-4f2c-a987-9303a779f576',
    'f77fd3f0-c80b-4959-930b-3c7050f5f89c',
    'f85c2473-02e1-4bcc-919d-9986e1ae0686',
    'f9c54b3a-2c22-48c4-965c-cdf4877886cf',
    'f9d68770-662e-48f3-8f14-07b3a24fdb45',
  ];
  const SEASONAL_TEMPLATE_IDS = [];

  const DEFAULT_LB_FILTERS = {
    statuses: {
      active: { enabled: true, label: 'Active' },
      paused: { enabled: true, label: 'Paused' },
      variants: { enabled: true, label: 'Variants' },
      deleted: { enabled: false, label: 'Deleted' },
    },
    formTypes: {
      popup: { enabled: true, label: 'Popup' },
      'inline-popup': { enabled: true, label: 'Inline Popup' },
      'smart-bar': { enabled: true, label: 'Smart Bar' },
      'scroll-box': { enabled: true, label: 'Scroll Box' },
      'click-trigger-popup': { enabled: true, label: 'Click Trigger' },
      'welcome-mat': { enabled: true, label: 'Welcome Mat' },
      'social-proof': { enabled: true, label: 'Social Proof' },
    },
  };

  const STATUS_DEFAULT_ENABLED = ['active', 'paused', 'variants'];

  const LB_FILTER_ORDER = [{
    type: 'statuses',
    order: ['active', 'paused', 'variants', 'deleted'],
  }, {
    type: 'formTypes',
    order: [
      'popup',
      'inline-popup',
      'smart-bar',
      'scroll-box',
      'click-trigger-popup',
      'welcome-mat',
      'social-proof',
    ],
  }];

  const DEFAULT_LB_TEST_FILTERS = {
    statuses: {
      active: { enabled: true, label: 'Active' },
      ended: { enabled: true, label: 'Ended' },
      archived: { enabled: false, label: 'Archived' },
    },
  };

  const STATUS_DEFAULT_TEST_ENABLED = ['active', 'ended'];

  const LB_TEST_FILTER_ORDER = [{
    type: 'statuses',
    order: ['active', 'ended', 'archived'],
  }];

  const EVENT_SOURCE_TYPES = {
    LEAD_SOURCE: 'LEAD_SOURCE',
    ECOMMERCE_SOURCE: 'ECOMMERCE_SOURCE',
    ZAPIER_SOURCE: 'ZAPIER_SOURCE',
    CUSTOM_SOURCE: 'CUSTOM_SOURCE',
    SHOPIFY: 'SHOPIFY',
    WOOCOMMERCE: 'WOOCOMMERCE',
  };

  const MEDIA_TYPES = {
    IMAGE: 'image',
    SVG: 'svg',
    VIDEO: 'video',
    ICON: 'icon',
  };

  const DEFAULT_EVENT_SOURCE_CONFIG_LEAD = {
    source_sub_type: null,
    source_list: [],
  };
  const DEFAULT_EVENT_SOURCE_CONFIG_ECOMMERCE = {
    source_sub_type: EVENT_SOURCE_TYPES.SHOPIFY,
  };
  const DEFAULT_EVENT_SOURCE_CONFIG_ZAPIER = {
    source_sub_type: null,
  };
  const DEFAULT_EVENT_SOURCE_CONFIG_CUSTOM = {
    source_sub_type: null,
  };

  const FIRST_TEXT_MAPPINGS = {
    [EVENT_SOURCE_TYPES.LEAD_SOURCE]: '{Name} from {Location}',
    [EVENT_SOURCE_TYPES.ECOMMERCE_SOURCE]: '{Name} from {Location}',
    [EVENT_SOURCE_TYPES.ZAPIER_SOURCE]: '{Name} from {Location}',
  };

  const SECOND_TEXT_MAPPINGS = {
    [EVENT_SOURCE_TYPES.LEAD_SOURCE]: 'Became a subscriber!',
    [EVENT_SOURCE_TYPES.ECOMMERCE_SOURCE]: 'Purchased a {Product}!',
    [EVENT_SOURCE_TYPES.ZAPIER_SOURCE]: 'Is a hero!',
  };

  const SP_CLOSE_BUTTON = {
    "className": "bdow-sp-close",
    "key": "bdow-sp-close",
    "redirectVariableName": "email",
    "fill": "normal",
    "errors": {},
    "redirectWindow": "current",
    "style": {
        "borderTopLeftRadius": "20px",
        "fill": "#000000",
        "borderTopRightRadius": "20px",
        "borderStyle": "solid",
        "width": "24px",
        "left": "300px",
        "height": "24px",
        "boxShadow": "0px 2px 6px 0px rgba(0,0,0,0.6), inset 0px 0px 0px rgba(0,0,0,0)",
        "margin": "0",
        "borderBottomWidth": "0",
        "borderBottomLeftRadius": "20px",
        "gradient": "",
        "padding": "5px",
        "borderLeftWidth": "0",
        "top": "0px",
        "backgroundColor": "rgba(245,245,245,1)",
        "borderRightWidth": "0",
        "borderColor": "rgba(255,255,255,1)",
        "borderBottomRightRadius": "20px",
        "borderWidth": "0",
        "borderTopWidth": "0",
        "borderRadius": "20px"
    },
    "action": "close",
    "type": "image",
    "id": "308279d7fe6aa9238510dc97e009253619a46cf92d1435a92f62a2377fc348fb",
    "to": "",
    "redirectMethod": "",
    "mediaType": "svg",
    "mediaId": "cfac457bdd16226e6268ace13d030504821fa7bab57378147d144294fd24fe6a"
};

const SUCCESS_STEP_JSON = {
  type: 'popup',
  components: [
    {
        "type": "background",
        "mediaId": "",
        "defaultMediaId": "",
        "style": {
            "borderTopLeftRadius": "6px",
            "fill": "rgba(0,0,0,1)",
            "borderTopRightRadius": "6px",
            "borderStyle": "solid",
            "width": "550px",
            "left": "0px",
            "height": "168px",
            "position": "relative",
            "boxShadow": "0px 0px 0px rgba(0,0,0,0)",
            "textShadow": "0px 0px 0px rgba(0,0,0,0)",
            "margin": "0",
            "borderBottomLeftRadius": "6px",
            "gradient": "",
            "padding": "0",
            "top": "0px",
            "backgroundColor": "rgba(239,239,239,1)",
            "borderColor": "rgba(0,0,0,1)",
            "borderBottomRightRadius": "6px",
            "borderWidth": "0px",
            "borderRadius": "6px"
        },
        "fill": "cover",
        "mediaType": "image"
    },
    {
        "type": "text",
        "text": "Success",
        "style": {
            "borderTopLeftRadius": "0px",
            "fontStyle": "normal",
            "color": "rgba(73,82,89,1)",
            "borderTopRightRadius": "0px",
            "borderStyle": "solid",
            "width": "508px",
            "left": "21px",
            "height": "34px",
            "fontWeight": "700",
            "boxShadow": "0px 0px 0px rgba(0,0,0,0), inset 0px 0px 0px rgba(0,0,0,0)",
            "textShadow": "0px 0px 0px rgba(0,0,0,0)",
            "margin": "0",
            "borderBottomLeftRadius": "0px",
            "fontSize": "23px",
            "gradient": "",
            "padding": "0",
            "fontFamily": "'Open Sans',sans-serif",
            "top": "19px",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "rgba(0,0,0,1)",
            "borderBottomRightRadius": "0px",
            "textAlign": "center",
            "borderWidth": "0px",
            "lineHeight": "1.5",
            "borderRadius": "0px"
        },
        "end": "Thu Mar 14 2019 11:37:10 GMT-0500 (Central Daylight Time)",
        "timezone": "America/Chicago",
        "format": "UU NN, hh:mm:ss"
    },
    {
        "type": "text",
        "text": "You are now subscribed.",
        "style": {
            "borderTopLeftRadius": "0px",
            "fontStyle": "normal",
            "color": "rgba(73,82,89,1)",
            "borderTopRightRadius": "0px",
            "borderStyle": "solid",
            "width": "508px",
            "left": "21px",
            "height": "24px",
            "fontWeight": "400",
            "boxShadow": "0px 0px 0px rgba(0,0,0,0), inset 0px 0px 0px rgba(0,0,0,0)",
            "textShadow": "0px 0px 0px rgba(0,0,0,0)",
            "margin": "0",
            "borderBottomLeftRadius": "0px",
            "fontSize": "16px",
            "gradient": "",
            "padding": "0",
            "fontFamily": "'Open Sans',sans-serif",
            "top": "61px",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "rgba(0,0,0,1)",
            "borderBottomRightRadius": "0px",
            "textAlign": "left",
            "borderWidth": "0px",
            "lineHeight": "1.5",
            "borderRadius": "0px"
        },
        "end": "Thu Mar 14 2019 11:37:10 GMT-0500 (Central Daylight Time)",
        "timezone": "America/Chicago",
        "format": "UU NN, hh:mm:ss"
    },
    {
        "redirectVariableName": "email",
        "redirectWindow": "current",
        "text": "Continue",
        "style": {
            "borderTopLeftRadius": "4px",
            "fontStyle": "normal",
            "color": "rgba(255,255,255,1)",
            "borderTopRightRadius": "4px",
            "borderStyle": "solid",
            "width": "508px",
            "left": "21px",
            "height": "50px",
            "fontWeight": "700",
            "boxShadow": "0px 0px 0px rgba(0,0,0,0), inset 0px 0px 0px rgba(0,0,0,0)",
            "textShadow": "0px 0px 0px rgba(0,0,0,0)",
            "margin": "0",
            "borderBottomLeftRadius": "4px",
            "fontSize": "16px",
            "gradient": "",
            "padding": "0",
            "fontFamily": "'Open Sans',sans-serif",
            "top": "99px",
            "backgroundColor": "rgba(15,116,181,1)",
            "borderColor": "rgba(0,0,0,1)",
            "borderBottomRightRadius": "4px",
            "borderWidth": "0px",
            "lineHeight": "1.5",
            "borderRadius": "4px"
        },
        "action": "close",
        "type": "button",
        "to": "",
        "redirectMethod": ""
    },
    {
        "redirectVariableName": "email",
        "fill": "normal",
        "redirectWindow": "current",
        "style": {
            "borderTopLeftRadius": "0px",
            "fill": "rgba(164,169,172,1)",
            "borderTopRightRadius": "0px",
            "borderStyle": "solid",
            "width": "16px",
            "left": "519px",
            "height": "16px",
            "boxShadow": "0px 0px 0px rgba(0,0,0,0), inset 0px 0px 0px rgba(0,0,0,0)",
            "margin": "0",
            "borderBottomLeftRadius": "0px",
            "gradient": "",
            "padding": "0",
            "top": "15px",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "rgba(0,0,0,1)",
            "borderBottomRightRadius": "0px",
            "borderWidth": "0px",
            "borderRadius": "0px"
        },
        "action": "close",
        "type": "image",
        "to": "",
        "redirectMethod": "",
        "mediaType": "svg",
        "defaultMediaId": "4720b373859b04afd757651cd6d7fb201973415db9d188b41026f6b394d52c88",
        "mediaId": "4720b373859b04afd757651cd6d7fb201973415db9d188b41026f6b394d52c88"
    }
],
};

  const DEFAULT_POPUP_RESPONSIVE_BREAKPOINTS = {
    Infinity: {
      shouldReview: false,
      label: 'Desktop',
    },
    480: {
      shouldReview: false,
      label: 'Mobile',
    },
  };

  return {
    InlineClassnames,
    SHAKE_ANIMATION,
    SLUG_TO_FEATURE,
    APP_ID,
    FormTypes,
    FormGoals,
    TAB_FORM_TYPES,
    ResponsiveFormats,
    SUMO_BADGE_PLACEMENT_VAL,
    SUMO_BADGE_HEIGHT_VAL,
    DEFAULT_TEMPLATE_ID,
    DISCOUNT_PRO_TIERS,
    GOALS,
    FORM_TYPES,
    ECOMMERCE_TEMPLATE_IDS,
    SEASONAL_TEMPLATE_IDS,
    DEFAULT_LB_FILTERS,
    LB_FILTER_ORDER,
    STATUS_DEFAULT_ENABLED,
    DEFAULT_LB_TEST_FILTERS,
    LB_TEST_FILTER_ORDER,
    STATUS_DEFAULT_TEST_ENABLED,
    EVENT_SOURCE_TYPES,
    MEDIA_TYPES,
    DEFAULT_EVENT_SOURCE_CONFIG_LEAD,
    DEFAULT_EVENT_SOURCE_CONFIG_ECOMMERCE,
    DEFAULT_EVENT_SOURCE_CONFIG_ZAPIER,
    DEFAULT_EVENT_SOURCE_CONFIG_CUSTOM,
    FIRST_TEXT_MAPPINGS,
    SECOND_TEXT_MAPPINGS,
    SP_CLOSE_BUTTON,
    SUCCESS_STEP_JSON,
    TESTABLE_FORM_TYPES,
    DEFAULT_POPUP_RESPONSIVE_BREAKPOINTS,
  };
});
